import { Spine } from "pixi-spine";
import * as PIXI from 'pixi.js';
import { Geometry, HorizontalAlign, LogGroup, Rect, Size, VerticalAlign } from "../.././MyHelpers";
import { DecodedImageResource } from "../../ResourceManager/ImageResource";
import { ResourceIdentifier } from "../../ResourceManager/ResourceIdentifier";
import { IReadOnlyResourceManager, IWriteOnlyResourceManager } from "../../ResourceManager/ResourceManager";
import { JackpotDisplayType, Settings } from "../../Settings";
import { JackpotAwardOption, JackpotLevel, SlotGameBet } from "../../api";
import { MyCanvas } from "../MyCanvas";
import { RewardColor, RewardOptionParams } from "./RewardOptionFactory";
import { IRewardOption } from "./ScatterRandomAward";
import { JackpotDisplayProperties } from "../../JackpotDisplayProperties";

/** jackpot that will be change x2 or x3 depends whit game multiplier  */
const jpMuliPlier = ["jp1","jp2"]

export class JackpotRewardOption implements IRewardOption
{
    protected readonly logGroup: LogGroup;
    protected readonly resid: ResourceIdentifier;
    protected readonly basePath: string = Settings.ResourcesFolder + "multigame/slot/common/resources/ScatterRandomAward";
    protected readonly config: JackpotAwardOption;

    protected image: DecodedImageResource;

    public constructor(params: RewardOptionParams, config: JackpotAwardOption, color: RewardColor)
    {
		if (!Object.values(JackpotLevel).includes(config.JackpotName as JackpotLevel))
		{
			throw `Jackpot ${config.JackpotName} not implemented`;
		}

        this.logGroup = params.logGroup.Add("JP").Add(config.JackpotName);
        this.resid = params.resid.Add("JP").Add(config.JackpotName);
        this.config = config;
    }
    
    public MultiplierAward() {
        //throw new Error("Method not implemented.");
        return undefined;
    }

    public Name(): string 
    {
        return this.config.AwardName;
    }

    //protected texture: PIXI.Texture;

    protected canvasSize: Size = new Size(0, 0);
    protected fitRatio: number;


    public async PrepareResources(resourceManager: IWriteOnlyResourceManager): Promise<void>
    {
        if (Settings.JackpotDisplayType != JackpotDisplayType.PaytableJackpotDisplay)
        {
            let jackpotName: string = Settings.JackpotDisplayType
            if (JackpotDisplayProperties[Settings.JackpotDisplayType].alias != null || JackpotDisplayProperties[Settings.JackpotDisplayType].alias != undefined ) jackpotName = JackpotDisplayProperties[Settings.JackpotDisplayType].alias;
            resourceManager.Add(new DecodedImageResource(this.basePath+"/" + jackpotName +"/"+ this.config.JackpotName + ".png", this.resid.ScopedResourceName("image")));	

            if(jpMuliPlier.find(j=>j == this.config.JackpotName)?.length > 0 ){
                console.log("JackpoMulti:",this.config);
                resourceManager.Add(new DecodedImageResource(this.basePath+"/" + jackpotName +"/"+ this.config.JackpotName + "X2.png", this.resid.ScopedResourceName("imageX2")));	
                resourceManager.Add(new DecodedImageResource(this.basePath+"/" + jackpotName +"/"+ this.config.JackpotName + "X3.png", this.resid.ScopedResourceName("imageX3")));
                resourceManager.Add(new DecodedImageResource(this.basePath+"/" + jackpotName +"/"+ this.config.JackpotName + "X4.png", this.resid.ScopedResourceName("imageX4")));	
                resourceManager.Add(new DecodedImageResource(this.basePath+"/" + jackpotName +"/"+ this.config.JackpotName + "X5.png", this.resid.ScopedResourceName("imageX5")));	
        
        	
            }            
        }
    }


    protected textureArray: PIXI.Texture<PIXI.Resource>[] = [];
    protected imgDecoded : DecodedImageResource [] = [];

    public async ResourcesLoaded(resourceManager: IReadOnlyResourceManager): Promise<void>
    {
        if (Settings.JackpotDisplayType != JackpotDisplayType.PaytableJackpotDisplay)
        {
            let imgX1 = resourceManager.Get<DecodedImageResource>(this.resid.Add("image"));
            this.imgDecoded.push(imgX1);

            let jpX1 = resourceManager.Get<DecodedImageResource>(this.resid.Add("image"));
            let textureX1 = PIXI.Texture.from(jpX1.DecodedImage());

            this.textureArray.push(textureX1);
            if(jpMuliPlier.find(j=>j == this.config.JackpotName)?.length > 0 ){
                let imgX2 = resourceManager.Get<DecodedImageResource>(this.resid.Add("imageX2"));
                this.imgDecoded.push(imgX2);

                let jpX2 = resourceManager.Get<DecodedImageResource>(this.resid.Add("imageX2"));
                let textureX2 = PIXI.Texture.from(jpX2.DecodedImage());
                this.textureArray.push(textureX2);


                let imgX3 = resourceManager.Get<DecodedImageResource>(this.resid.Add("imageX3"));
                this.imgDecoded.push(imgX3);
                let jpX3 = resourceManager.Get<DecodedImageResource>(this.resid.Add("imageX3"));
                let textureX3 = PIXI.Texture.from(jpX3.DecodedImage());
                this.textureArray.push(textureX3);

                let imgX4 = resourceManager.Get<DecodedImageResource>(this.resid.Add("imageX4"));
                this.imgDecoded.push(imgX4);
                let jpX4 = resourceManager.Get<DecodedImageResource>(this.resid.Add("imageX4"));
                let textureX4 = PIXI.Texture.from(jpX4.DecodedImage());
                this.textureArray.push(textureX4);

                let imgX5 = resourceManager.Get<DecodedImageResource>(this.resid.Add("imageX5"));
                this.imgDecoded.push(imgX5);
                let jpX5 = resourceManager.Get<DecodedImageResource>(this.resid.Add("imageX5"));
                let textureX5 = PIXI.Texture.from(jpX5.DecodedImage());
                this.textureArray.push(textureX5);
                
            }  
        }
    }

    public UpdateBet(bet: SlotGameBet): void
    {
    }

    public DrawTo(canvas: MyCanvas)
    {
        let fitRect = Geometry.ScaleRect(Geometry.FitRect(this.image.DecodedRect(), canvas.rect, HorizontalAlign.Center, VerticalAlign.Center), 0.5, 0.5);
        canvas.context.drawImage(
            this.image.DecodedImage(),

            // source rect
            0, 0, this.image.DecodedSize().Width, this.image.DecodedSize().Height,

            // dest rect
            fitRect.x, fitRect.y, fitRect.width, fitRect.height
            //0, 0, canvas.size.width, canvas.size.height
        );
    }

    //draw img to pixi


    protected jackpotMultiplier = 0 ;
    
    public DrawToPIXI(canvas: PIXI.AnimatedSprite, symbolsSize?: Size , strValueMultiplier? : string ,  jackpotMultiplier?  : number     ) {


        let element = canvas.parent.children.find(element => element.name == "SRAjackpot");
      
        
        if(jackpotMultiplier == undefined) jackpotMultiplier = 1 ;

        if(jpMuliPlier.find(j=>j == this.config.JackpotName) == undefined ) jackpotMultiplier = 1 ;
        
        
        // element.visible = true;
       
            this.canvasSize = new Size(canvas.width, canvas.height);
            this.fitRatio = Geometry.FitRectRatio(
                this.imgDecoded[jackpotMultiplier - 1 ].DecodedRect(),
                new Rect(0, 0, symbolsSize?.Width > 0 ? symbolsSize?.Width : canvas.width , symbolsSize?.Height > 0  ? symbolsSize?.Height : canvas.height),
            ) * 0.66;
  

        let jpCanvas = element as PIXI.Sprite;

        



        jpCanvas.texture = this.textureArray[jackpotMultiplier - 1];
        jpCanvas.anchor.set(0.5, 0.5);
        jpCanvas.scale.set(this.fitRatio, this.fitRatio);

        //hide cash and shadow container
        //show SRAjackpot  
        canvas.parent.children.forEach(element=>{
            if(element.name == "SRAjackpot") element.visible = true; 
            if(element.name == "SRAshadowText") element.visible = false; 
            if(element.name == "SRAvalue") element.visible = false; 
        });
    }

    public TextToDraw(): string
    {
        return "JACKPOT " + this.config.JackpotName;
    }

    public Update(): void
    {
        
    }

    public DrawToSpine(spine: Spine, symbolsSize?: Size, strValueMultiplier?: string, jackpotMultiplier?: number , awardShow? : boolean) {


        //let element = canvas.parent.children.find(element => element.name == "SRAjackpot");


        if (jackpotMultiplier == undefined) jackpotMultiplier = 1;

        if (jpMuliPlier.find(j => j == this.config.JackpotName) == undefined) jackpotMultiplier = 1;

       
        let valueContainer = spine?.slotContainers.find(container => container.name == "value");

     
        
           
        
        if (valueContainer != null) {
            if (awardShow == false)
                valueContainer?.children.forEach(ele => {
                    ele.removeFromParent();
                    ele.destroy(false)
                });


            this.canvasSize = new Size(spine.width, spine.height);
            this.fitRatio = Geometry.FitRectRatio(
                this.imgDecoded[jackpotMultiplier - 1 ].DecodedRect(),
                new Rect(0, 0, 600 , 500),
            ) * 0.66 ;        

            // create a new Sprfite from an image path.
            let jpCanvas = new PIXI.Sprite();
            //jpCanvas.width = spine.width / 2;
            //jpCanvas.height = spine.height / 5;
            jpCanvas.anchor.set(0.5, 0.5);
            //jpCanvas.x = Math.round((spine.width) / 2);
            //jpCanvas.y = Math.round(spine.height / 2);
            jpCanvas.name = "SRAjackpot";
            valueContainer.addChild(jpCanvas);
            jpCanvas.texture = this.textureArray[jackpotMultiplier - 1];
            jpCanvas.anchor.set(0.5, 0.5);
            jpCanvas.scale.set(this.fitRatio, ( this.fitRatio * -1 ));
        }
    }
}
